var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconInvestments64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 57.5029C45.8071 57.5029 57 46.31 57 32.5029C57 18.6958 45.8071 7.50293 32 7.50293C18.1929 7.50293 7 18.6958 7 32.5029C7 46.31 18.1929 57.5029 32 57.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 48.9316C41.0731 48.9316 48.4284 41.5763 48.4284 32.503C48.4284 23.4298 41.0731 16.0745 31.9999 16.0745C22.9266 16.0745 15.5713 23.4298 15.5713 32.503C15.5713 41.5763 22.9266 48.9316 31.9999 48.9316Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2968 53.0254L15.2744 56.0589",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7159 53.0171L48.7134 56.067",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 40.3603C36.3396 40.3603 39.8574 36.8425 39.8574 32.5031C39.8574 28.1638 36.3396 24.646 32.0002 24.646C27.6608 24.646 24.1431 28.1638 24.1431 32.5031C24.1431 36.8425 27.6608 40.3603 32.0002 40.3603Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconInvestments64);
export default __webpack_public_path__ + "static/media/pictogramBeaconInvestments64.f4cebe886dd2ab056f88d42676f10b79.svg";
export { ForwardRef as ReactComponent };